import { Chip } from "@mui/material";
import React from "react";
import { getServiceRequestBgColor, getServiceRequestColor } from "../utils";


// create status chip component
export const StatusChip = ({ status }: { status: string }) => {
  let mappedStatus;
  switch (status) {
    case "new":
      mappedStatus = "New Request";
      break;
    case "in_progress":
      mappedStatus = "In Progress";
      break;
    case "pending_response":
      mappedStatus = "Pending Response";
      break;
    case "closed":
      mappedStatus = "Closed";
      break;
    default:
      mappedStatus = "Unknown";
      break;
  }
  return (
    <Chip
      label={mappedStatus}
      style={{
        backgroundColor: getServiceRequestBgColor(status),
        minWidth: "75px",
        fontWeight: 500,
        color: getServiceRequestColor(status),
      }}
    />
  );
}; 